import React from "react";
import { CardWrapper } from "../assets/style";
import { CheckBox } from "components/CheckBox";


/**
 * @description
 * address card component which renders individual address elements
 * @param AddressCardProps
 * @returns - card component
 */
export const AddressCard = ({
  isDefault,
  tag,
  isChecked = false,
  address,
  handleCheckBoxClick,
  handleEditClick,
  defaultTitle,
  editTitle,
}: AddressCardProps) => {
  const {
    firstName,
    city,
    postcode,
    region,
    street,
    phone,
    customerAddressId,
  } = address;


  return (
    <CardWrapper isChecked={isChecked} onClick={() => handleCheckBoxClick(address)}>
      <div className="layout vertical">
        {
          isDefault && (
            <div className="layout horizontal center mb4">
              <p className="font-semibold default">{defaultTitle}</p>
              <CheckBox
                isChecked={isChecked}
              />
            </div>
          )
        }
        <div className="layout horizontal center mb4">
          <p className="font-medium" style={ { color: "rgba(0,19,37,0.92)" } }>{firstName}</p>
          {/* tag can be passed as per design when received from backend in future */}
          {
            tag && (
              <div className="label">
                {tag}
              </div>
            )
          }
          {
            !isDefault && (
              <CheckBox
                isChecked={isChecked}
              />
            )
          }
        </div>
      </div>
      <div className="layout vertical address" data-testid="txt_address_bar">
        {street}, {region}
        <p className="font-medium">{city}-{postcode}</p>
        {/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div className="layout horizontal">
          <p className="font-medium">{phone}</p>
          <div className="font-medium edit-address" data-testid="address_edit_btn" onClick={() => handleEditClick(customerAddressId)}>{editTitle}</div>
        </div>
      </div>
    </CardWrapper>
  );
};
